import Vue from 'vue'
import vClickOutside from 'v-click-outside'

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

Vue.use(vClickOutside)
